/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Saved_PromptsInputs */



/**
* | output |
* | --- |
* | "Saved prompts" |
*
* @param {Assistant_Saved_PromptsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_saved_prompts = /** @type {((inputs?: Assistant_Saved_PromptsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Saved_PromptsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Invites enregistrées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gespeicherte Eingabeaufforderungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Prompt salvati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранённые запросы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solicitudes guardadas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已保存的提示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存したプロンプト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहेजे गए प्रॉम्प्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prompts guardados")
	return /** @type {LocalizedString} */ ("Saved prompts")
});